<template>
  <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
    <ts-loading-banner :loading="loading">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center">
              {{ $t('saleContract.unitPriceSold') }}
            </th>
            <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center">
              {{ $t('saleContract.uThbSold') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="products.length == 0">
            <td class="ts-text-red-500 ts-h-10 ts-text-center" colspan="2">
              No Sold Price
            </td>
          </tr>
          <tr
            v-for="(price, index) in products"
            :key="index"
            class="ts-cursor-pointer hover:ts-bg-gray-300"
            :class="{
              active: current_active == price.unit_price,
            }"
            @click="selectItem(price.unit_price)"
          >
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-right">
              {{ $currencyFormat(price.unit_price) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-right">
              {{ $currencyFormat(price.unit_price * 32, 'THB', 'th-TH') }}
            </td>
          </tr>
        </tbody>
      </table>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'soldPrice',
  props: ['product', 'value'],
  data() {
    return {
      loading: true,
      current_active: null,
      products: [],
      model: {},
    }
  },
  created() {
    this.fetchPrice()
    this.model = this.value
  },
  methods: {
    ...mapActions('wholesale/operation', ['getFormViewData']),
    fetchPrice() {
      this.loading = true
      this.getFormViewData({
        params: {
          fnName: 'soldPrice',
          product_id: this.product.product_id,
          customer_id: this.model.customer_id,
        },
      })
        .then((response) => {
          this.products = response.data['soldPrice']
        })
        .catch((err) => {
          this.$toasted.error(err.message)
        })
        .finally(() => (this.loading = false))
    },
    selectItem(price) {
      this.current_active = price
      this.model.product_detail.find(
        (e) => e.product_id == this.product.product_id
      )['unit_price'] = parseFloat(price)
      this.$emit('priceChange')
    },
  },
}
</script>
<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
.active {
  background: rgba(209, 213, 219);
}
</style>